
import fetchUDNReport from './fetchUDNReport'

export default {
  fetchUDNReport,
}


// WEBPACK FOOTER //
// ./src/services/reports/index.js